// extracted by mini-css-extract-plugin
export default {"main":"ResetPasswordLobby_main__HGvhc"};